import { useEffect, useMemo } from 'react';
import classNames from 'classnames';

const HiddenInput = ({ onChangePlainValue, value, validationError, hideError, className }) => {
	const plainValue = useMemo(() => {
		return (value ?? '').toString();
	}, [value]);

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue, onChangePlainValue]);

	if(validationError && !hideError) {
		return (
			<div className={classNames('type-hidden', className)}>
				<div className="input-error">{validationError}</div>
			</div>
		)
	}

	return null;
};

export default HiddenInput;
